import "./Hero.scss";
import { useTranslation } from "react-i18next";
import {Eye, Flame, Play, TrendingUp} from "lucide-react";
import { Link, NavLink } from "react-router-dom";

const stats = [
    {
        value: "5.8M+",
        type: "views"
    },
    {
        value: "14",
        type: "server"
    },
    {
        value: "3",
        type: "platform"
    },
];

export default function Hero() {
    const { t } = useTranslation();
    return (
        <section className="minecraft-hero">
            <div className="minecraft-hero__glow" />

            <div className="minecraft-hero__container">
                {/* LEFT */}
                <div className="minecraft-hero__content">

                    <h1 className="minecraft-hero__title">
                        {t("home.hero.title.normalup")}
                        <br />
                        {t("home.hero.title.normaldown")}
                        <br />
                        <span>{t("home.hero.title.bold")}</span>
                    </h1>

                    <p className="minecraft-hero__description">
                        {t("home.hero.subtitleup")}
                        <br className="desktop-only" />
                        {t("home.hero.subtitledown")}
                    </p>

                    <div className="minecraft-hero__actions">
                        <Link to="/servizi" className="minecraft-hero__button">
                            {t("home.hero.button.start")}
                        </Link>

                        <Link to="lavori" className="minecraft-hero__button minecraft-hero__button--secondary">
                            <Play size={20}/>
                            {t("home.hero.button.lookWorks")}
                        </Link>
                    </div>

                    <div className="minecraft-hero__stats">
                        {stats.map((stat) => (
                            <div className="minecraft-hero__stat" key={stat.value}>
                                <strong>{stat.value}</strong>
                                <span>{t(`home.hero.stats.${stat.type}`)}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* RIGHT */}
                <div className="minecraft-hero__visual">
                    <div className="minecraft-hero__frame">
                        <div className="minecraft-hero__video">
                            <div className="minecraft-hero__video-glow" />

                            <div className="minecraft-hero__play">
                                <span>▶</span>
                            </div>

                            <div className="minecraft-hero__video-info">
                                <strong>Minecraft</strong>
                                <span>Short-form content</span>
                            </div>

                            <div className="minecraft-hero__video-footer">
                                <p>
                                    POV: you just joined the best studios
                                    <br />
                                    ever
                                </p>

                                <div className="minecraft-hero__video-stats">
                                    <div>
                                        <span className="mini-play">▶</span>
                                        <strong>12.4M</strong>
                                    </div>

                                    <div>
                                        <span className="mini-circle"><Eye size={15} /></span>
                                        <strong>847K</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Floating cards */}
                        <div className="floating-card floating-card--views">
                            <div className="floating-card__icon"><TrendingUp /></div>
                            <div>
                                <strong>5.8M+</strong>
                                <span>{t(`home.hero.stats.views`)}</span>
                            </div>
                        </div>

                        <div className="floating-card floating-card--trending">
                            <div className="floating-card__fire"><Flame size={20} /></div>
                            <div>
                                <strong>#Trending</strong>
                                <span>{t(`home.hero.stats.platform`)}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
